import type { SupportArticle } from './content';

/** Bỏ dấu tiếng Việt để `dang nhap` khớp `đăng nhập`. `đ` không tách được bằng NFD. */
export function foldVietnamese(value: string): string {
  return value
    .toLowerCase()
    .replace(/đ/g, 'd')
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

export function filterArticles(
  articles: readonly SupportArticle[],
  query: string,
  topicId: string | null,
): SupportArticle[] {
  const needle = foldVietnamese(query.trim());

  return articles.filter((article) => {
    if (topicId !== null && article.topicId !== topicId) return false;
    if (needle.length === 0) return true;

    const haystack = foldVietnamese(
      [article.title, article.summary, ...article.steps].join(' '),
    );
    return haystack.includes(needle);
  });
}
